// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/*######################################################################
  H E A D E R
/*####################################################################*/


#avp-header-container{
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 20px;
    padding-bottom: 10px;
    background: linear-gradient(to right, #010101 0%, #618089 100%);
  }
  
  #avp-header-container-left{
    float: left;
    width: auto;
  }
  
  #avp-header-logo-img{
      /* padding-top: 10px; */
      margin-right: 25px;
      height: 30px;
  }
  
  #avp-header-profilo-box {
    display: inline-block;
  }
  
  #avp-header-profilo-status {
      position: absolute;
      top: 50px;
      right: 24px;
      height: 25px;
      width: 25px;
      background-color: #bbb;
      border-radius: 50%;
      display: inline-block;
      z-index: 30;
      border: 3px solid white;
  }
  
  
  #avp-header-profilo-img{
    width: 100%;
    max-width: 30px;
    height: 30px;
    border-radius: 50%;
    object-fit: cover;
  }

  #avp-header-profilo-name {
    padding-left: 10px;
    padding-right: 10px;
    color: #ffffff;
  }
  
  #avp-header-profilo-img-mobile{
    width: 100%;
    max-width: 59px;
    height: 59px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  #avp-header-mobile{
    display: none;
  }
  
  #avp-menu-desktop{
    padding-left: 50px;
    margin-bottom: 0;
    list-style-type: none;
  }

  #avp-menu-desktop li {
    display: inline;
    margin-right: 20px;
    
  }
  
  #avp-menu-desktop li a {
    color: #FFFFFF;
    text-decoration: none;
  }
  
  #avp-menu-desktop li a.avp-menu-link-attivo {
    text-decoration: underline;
  }

  #avp-header-container-right{
    float: right;
    width: auto;
    text-align: right;
  }
  

  
  #avp-header-notifiche-img-div{
    display: inline-block;
    position: relative;
  }
  
  #avp-header-notifiche-numero{
    position: absolute;
    top: -2px;
    right: -12px;
    /*padding: 1px 10px;*/
    padding: 3px 14px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px 20px;
    color: white;
    font-size: 11px;
    cursor: pointer;
  }
  
  #avp-header-logo-container{
    float: left;
  }
  
  #avp-header-titolo-modulo{
    float: left;
    font-size: 30px;
    font-family: "Dosis", sans-serif;
    color: #ffffff;
    padding-top: 4px;
  }
  
  #avp-header-menu-modulo{
    float: left;
  }
  
  #avp-menu{
    width: 342px;
    height: 442px;
    position: absolute;
    top: 75px;
    right: 45px;
    z-index: 50;
    padding-top: 20px;
    padding-bottom: 70px;
    padding-left: 21px;
    padding-right: 21px;
    /*
    background: url(../../shared/images/ballon_moduli.png);
    */
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: none;
  }
  
  .as-menu-balloon-title{
    padding-top: 7px;
    line-height: 20px;
    font-family: "Dosis", sans-serif;
  }
  
  .as-menu-balloon-img{
    width: 50px;
    height: 50px;
  }
  
  #avp-menu-container{
    height: 100%;
    position: relative;
  }
  
  #avp-menu-right-title{
    font-size: 25px;
    text-align: center;
    padding-top: 25px;
  }
  
  #avp-header-logout {
    position: relative;
    float: right;
    cursor: pointer;
    margin-left: 10px;
  }

  #avp-header-divider {
    position: relative;
    float: right;
  }

#avp-breadcrumb-container {
    background: #FFFFFF;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    padding-bottom: 10px;
}

.avp-breadcrumb-help {
  position: relative;
  float: right;
  width: 30px;
  cursor: pointer;
}
  
.avp-breadcrumb-item {
  position: relative;
  float: left;
  margin-right: 10px;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
  color: #9A9A9A;
}

.avp-breadcrumb-item a {
  color: #9A9A9A;
  text-decoration: none;
}

.avp-breadcrumb-item-last {
  position: relative;
  float: left;
  margin-right: 10px;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
  color: #282828;
}

.avp-breadcrumb-item-last a {
  color: #282828;
  text-decoration: none;
}

  @media screen and (max-width: 1199px) and (min-width: 992px){
  
  }
  
  
  
  @media screen and (max-width: 991px) and (min-width: 768px){
    
  }
  
  
  
  @media screen and (max-width: 767px) and (min-width: 576px){
   
  }
  
  
  
  @media only screen and (max-width: 575px){

  }`, "",{"version":3,"sources":["webpack://./src/shared/header/avp_header.css"],"names":[],"mappings":";;AAEA;;uEAEuE;;;AAGvE;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,+DAA+D;EACjE;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;MACI,uBAAuB;MACvB,kBAAkB;MAClB,YAAY;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;MACI,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,YAAY;MACZ,WAAW;MACX,sBAAsB;MACtB,kBAAkB;MAClB,qBAAqB;MACrB,WAAW;MACX,uBAAuB;EAC3B;;;EAGA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,kBAAkB;;EAEpB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;;;;EAIA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB;;KAEC;IACD,4BAA4B;IAC5B,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;AAEF;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;EAEE;;EAEA;;;;EAIA;;EAEA;;;;EAIA;;EAEA;;;;EAIA;;EAEA","sourcesContent":["\r\n\r\n/*######################################################################\r\n  H E A D E R\r\n/*####################################################################*/\r\n\r\n\r\n#avp-header-container{\r\n    padding-left: 25px;\r\n    padding-right: 25px;\r\n    padding-top: 20px;\r\n    padding-bottom: 10px;\r\n    background: linear-gradient(to right, #010101 0%, #618089 100%);\r\n  }\r\n  \r\n  #avp-header-container-left{\r\n    float: left;\r\n    width: auto;\r\n  }\r\n  \r\n  #avp-header-logo-img{\r\n      /* padding-top: 10px; */\r\n      margin-right: 25px;\r\n      height: 30px;\r\n  }\r\n  \r\n  #avp-header-profilo-box {\r\n    display: inline-block;\r\n  }\r\n  \r\n  #avp-header-profilo-status {\r\n      position: absolute;\r\n      top: 50px;\r\n      right: 24px;\r\n      height: 25px;\r\n      width: 25px;\r\n      background-color: #bbb;\r\n      border-radius: 50%;\r\n      display: inline-block;\r\n      z-index: 30;\r\n      border: 3px solid white;\r\n  }\r\n  \r\n  \r\n  #avp-header-profilo-img{\r\n    width: 100%;\r\n    max-width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n  }\r\n\r\n  #avp-header-profilo-name {\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n    color: #ffffff;\r\n  }\r\n  \r\n  #avp-header-profilo-img-mobile{\r\n    width: 100%;\r\n    max-width: 59px;\r\n    height: 59px;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n  }\r\n  \r\n  #avp-header-mobile{\r\n    display: none;\r\n  }\r\n  \r\n  #avp-menu-desktop{\r\n    padding-left: 50px;\r\n    margin-bottom: 0;\r\n    list-style-type: none;\r\n  }\r\n\r\n  #avp-menu-desktop li {\r\n    display: inline;\r\n    margin-right: 20px;\r\n    \r\n  }\r\n  \r\n  #avp-menu-desktop li a {\r\n    color: #FFFFFF;\r\n    text-decoration: none;\r\n  }\r\n  \r\n  #avp-menu-desktop li a.avp-menu-link-attivo {\r\n    text-decoration: underline;\r\n  }\r\n\r\n  #avp-header-container-right{\r\n    float: right;\r\n    width: auto;\r\n    text-align: right;\r\n  }\r\n  \r\n\r\n  \r\n  #avp-header-notifiche-img-div{\r\n    display: inline-block;\r\n    position: relative;\r\n  }\r\n  \r\n  #avp-header-notifiche-numero{\r\n    position: absolute;\r\n    top: -2px;\r\n    right: -12px;\r\n    /*padding: 1px 10px;*/\r\n    padding: 3px 14px;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    background-size: 20px 20px;\r\n    color: white;\r\n    font-size: 11px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  #avp-header-logo-container{\r\n    float: left;\r\n  }\r\n  \r\n  #avp-header-titolo-modulo{\r\n    float: left;\r\n    font-size: 30px;\r\n    font-family: \"Dosis\", sans-serif;\r\n    color: #ffffff;\r\n    padding-top: 4px;\r\n  }\r\n  \r\n  #avp-header-menu-modulo{\r\n    float: left;\r\n  }\r\n  \r\n  #avp-menu{\r\n    width: 342px;\r\n    height: 442px;\r\n    position: absolute;\r\n    top: 75px;\r\n    right: 45px;\r\n    z-index: 50;\r\n    padding-top: 20px;\r\n    padding-bottom: 70px;\r\n    padding-left: 21px;\r\n    padding-right: 21px;\r\n    /*\r\n    background: url(../../shared/images/ballon_moduli.png);\r\n    */\r\n    background-repeat: no-repeat;\r\n    background-size: 100% 100%;\r\n    display: none;\r\n  }\r\n  \r\n  .as-menu-balloon-title{\r\n    padding-top: 7px;\r\n    line-height: 20px;\r\n    font-family: \"Dosis\", sans-serif;\r\n  }\r\n  \r\n  .as-menu-balloon-img{\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n  \r\n  #avp-menu-container{\r\n    height: 100%;\r\n    position: relative;\r\n  }\r\n  \r\n  #avp-menu-right-title{\r\n    font-size: 25px;\r\n    text-align: center;\r\n    padding-top: 25px;\r\n  }\r\n  \r\n  #avp-header-logout {\r\n    position: relative;\r\n    float: right;\r\n    cursor: pointer;\r\n    margin-left: 10px;\r\n  }\r\n\r\n  #avp-header-divider {\r\n    position: relative;\r\n    float: right;\r\n  }\r\n\r\n#avp-breadcrumb-container {\r\n    background: #FFFFFF;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n    padding-top: 20px;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.avp-breadcrumb-help {\r\n  position: relative;\r\n  float: right;\r\n  width: 30px;\r\n  cursor: pointer;\r\n}\r\n  \r\n.avp-breadcrumb-item {\r\n  position: relative;\r\n  float: left;\r\n  margin-right: 10px;\r\n  font-family: \"Open Sans\";\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  line-height: 21px;\r\n  text-align: left;\r\n  color: #9A9A9A;\r\n}\r\n\r\n.avp-breadcrumb-item a {\r\n  color: #9A9A9A;\r\n  text-decoration: none;\r\n}\r\n\r\n.avp-breadcrumb-item-last {\r\n  position: relative;\r\n  float: left;\r\n  margin-right: 10px;\r\n  font-family: \"Open Sans\";\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  line-height: 21px;\r\n  text-align: left;\r\n  color: #282828;\r\n}\r\n\r\n.avp-breadcrumb-item-last a {\r\n  color: #282828;\r\n  text-decoration: none;\r\n}\r\n\r\n  @media screen and (max-width: 1199px) and (min-width: 992px){\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  @media screen and (max-width: 991px) and (min-width: 768px){\r\n    \r\n  }\r\n  \r\n  \r\n  \r\n  @media screen and (max-width: 767px) and (min-width: 576px){\r\n   \r\n  }\r\n  \r\n  \r\n  \r\n  @media only screen and (max-width: 575px){\r\n\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
